const dttmToFilteredData =
	<T>(data: T[], key: keyof T) =>
	(dttm: any) =>
		data.filter(sameTimestamp(dttm, key));

const sameTimestamp = <T>(dttm: any, key: keyof T) => {
	return (data: T) => {
		return data[key] === dttm;
	};
};

export const groupData = <T>(incomingData: T[], key: keyof T): T[][] => {
	const dttms = incomingData.map((la) => la[key]).filter((dttm, i, arr) => i === arr.indexOf(dttm));
	return dttms.map(dttmToFilteredData(incomingData, key));
};
